import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Optional,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

require('./visit-schedule-agent-import-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-visit-schedule-agent-import-dialog',
  templateUrl: './visit-schedule-agent-import-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitScheduleAgentImportDialogComponent implements OnInit {

  @Output() onClose = new EventEmitter<string[]>();

  public selectedAgentIds: string[] = [];

  constructor(
    @Optional() @Inject(PANEL_DATA) public data: { visitPlanId: string, visitScheduleId: string }
  ) {
  }

  ngOnInit() {
  }

  onSelectionChange(selectedIds: string[]) {
    this.selectedAgentIds = selectedIds;
  }

  onSubmit() {
    this.onClose.emit(this.selectedAgentIds);
  }

  onCancel() {
    this.onClose.emit();
  }
}
